module.exports = __webpack_public_path__ + "media/images/undraw_shopping_app_flsj-3b8f81113c5179137e4099832c45e70c.svg";